export const SET_STATES = "importExport/SET_STATES";
export const SET_CITIES = "importExport/SET_CITIES";
export const SET_UNITS = "importExport/SET_UNITS";
export const SET_ACCESSORIES = "importExport/SET_ACCESSORIES";
export const SET_CESS = "importExport/SET_CESS";
export const SET_CESS_GENERAL_DUTY = "importExport/SET_CESSGENERALDUTY";
export const SET_CONTAINER_SEAL_TYPES = "importExport/SET_CONTAINER_SEAL_TYPES";
export const SET_CONTAINER_SIZES = "importExport/SET_CONTAINER_SIZES";
export const SET_CONTAINER_TYPES = "importExport/SET_CONTAINER_TYPES";
export const SET_COUNTRIES = "importExport/SET_COUNTRIES";
export const SET_DISTRICT_CODES = "importExport/SET_DISTRICT_CODES";
export const SET_DOCUMENT_TYPE_CODES = "importExport/SET_DOCUMENT_TYPE_CODES";
export const SET_CURRENCIES = "importExport/SET_CURRENCIES";
export const SET_DECLARATIONS = "importExport/SET_DECLARATIONS";
export const SET_RODTEPS = "importExport/SET_RODTEPS";
export const SET_END_USES = "importExport/SET_END_USES";
export const SET_EXPORTER_TYPES = "importExport/SET_EXPORTER_TYPES";
export const SET_EXPORT_UNDERS = "importExport/SET_EXPORT_UNDERS";
export const SET_GOODS_STUFFED_AT = "importExport/SET_GOODS_STUFFED_AT";
export const SET_GST_IN_TYPES = "importExport/SET_GST_IN_TYPES";
export const SET_IGST_PAYMENT_STATUS = "importExport/SET_IGST_PAYMENT_STATUS";
export const SET_NATURE_OF_CARGO = "importExport/SET_NATURE_OF_CARGO";
export const SET_SEAL_TYPES = "importExport/SET_SEAL_TYPES";
export const SET_SHIPMENT_TYPES = "importExport/SET_SHIPMENT_TYPES";
export const SET_SHOW_FOB_INS = "importExport/SET_SHOW_FOB_INS";
export const STORE_SHOW_NATURE_OF_PAYMENTS = "importExport/STORE_SHOW_NATURE_OF_PAYMENTS";
export const SET_TERMS_OF_INVOICES = "importExport/SET_TERMS_OF_INVOICES";
export const SET_UNIT_PRICE_INCLUDES = "importExport/SET_UNIT_PRICE_INCLUDES";
export const SET_EXIM_SCHEME_CODES = "importExport/SET_EXIM_SCHEME_CODES";
export const SET_RITC_CODES = "importExport/SET_RITC_CODES";
export const SET_FOREIGN_PORTS = "importExport/SET_FOREIGN_PORTS";
export const SET_HOME_PORTS = "importExport/SET_HOME_PORTS";
export const SET_PTA_FTAS = "importExport/SET_PTA_FTAS";
export const SET_DRAW_BACK_RATES = "importExport/SET_DRAW_BACK_RATES";
export const STORE_ESANCHIT_SUPPORTING_DOCS = "importExport/STORE_ESANCHIT_SUPPORTING_DOCS";
